<template>
  <AppGradientBackground>
    <AppSkipLink href="#main" />
    <HeaderNavBar />
    <div class="min-h-screen">
      <AppBreadcrumbs :page-name="topicpageName" />
      <div class="page-wrapper">
        <GlobalNotificationContainer :show="!!notifications.title" />
        <main id="main">
          <slot />
        </main>
      </div>
    </div>
    <div class="mb-[9.2rem]">
      <AppFooter />
    </div>
  </AppGradientBackground>
</template>

<script lang="ts" setup>
import AppFooter from '../components/AppFooter.vue';

const notifications = useNotificationStore();
const topicpageName = (useAttrs()['page-name'] as string) || '';

useHead({
  htmlAttrs: {
    class: 'scroll-pb-[14rem]',
  },
});
</script>

<style lang="scss" scoped></style>
